import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <nav className='navbar navbar-custom navbar-fixed-top' role='navigation'>
      <div className='container'>
        <div className='navbar-header'>
          <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='#hamburger-menu'>
            <span className='sr-only'>Toggle</span>
            <span className='icon-bar'></span>
            <span className='icon-bar'></span>
            <span className='icon-bar'></span>
          </button>
          <Link className='navbar-brand' to='/'>Sukhchander Khanna</Link>
        </div>

        <div className='collapse navbar-collapse' id='hamburger-menu'>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#intro' data-toggle='collapse' data-target='.navbar-collapse.in'>Home</a>
            </li>
            <li>
              <a href='#profile' data-toggle='collapse' data-target='.navbar-collapse.in'>About</a>
            </li>
            <li>
              <a href='#connect' data-toggle='collapse' data-target='.navbar-collapse.in'>Connect</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
